import { requiresAuth, requiresTerms } from "@/middleware";

const CoursesView = () => import("./CoursesView.vue");

const coursesRoutes = [
  {
    path: "/courses",
    name: "CoursesView",
    component: CoursesView,
    meta: {
      middleware: [requiresAuth, requiresTerms]
    }
  }
];

export default coursesRoutes;
